import { render, staticRenderFns } from "./MySelectClients.vue?vue&type=template&id=01d4eec6&"
import script from "./MySelectClients.vue?vue&type=script&lang=js&"
export * from "./MySelectClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports